import {until} from 'lit-html/directives/until';
import {wrapUnsafeHtml} from "@modules/wrap-unsafe-html";
import {generalAriaLabels} from '@modules/i18n-labels';
import '@modules/aofl-form';

export default (ctx, html) => html`
  <aofl-form>
    <div class="mb-3 d-flex ${ctx['column-layout'] ? 'flex-column' : ' flex-row align-items-center'}">
      <form @submit="${ctx.search}">
        <div class="form-group search-form-group mb-0">
          <input
            id="query"
            type="text"
            name="search_term"
            autocomplete="off"
            class="form-control form-control-sm"
            placeholder="${until(ctx.placeholder)}"
            @input="${ctx.onInput}"
            title="Search"
            .value="${ctx.searchTerm}">
          <div class="search-btns">
            <button type="submit" class="btn" aria-label="${until(generalAriaLabels.SEARCH)}"><span class="ai ai-search"></span></button>
          </div>
        </div>
      </form>
      <button class="btn btn-link ${!ctx.searchTerm ? 'd-none' : ''}" @click="${ctx.clearSearch}">${until(ctx._r(ctx.__('<tt-mkEYNv/R>', '%r1%'), ctx['reset-text']))}</button>
    </div>
  </aofl-form>
`;
